import { useState } from 'react'

import type { ShipmentListPreference } from '@fv/models'

import { useUserSettings } from '@/hooks/settings'

import { CalendarShipmentList } from '../shipment-calendar/CalendarShipmentList'
import { ConfirmedFiltersProvider } from '../shipment-filters/ConfirmedFiltersProvider'
import CondensedShipmentList from '../shipment-table/CondensedShipmentList'
import { ConfirmedShipmentList } from './ConfirmedShipmentList'

export const ActiveShipmentsPage = () => {
  const settingsQuery = useUserSettings()
  const [view, setView] = useState<ShipmentListPreference>(
    settingsQuery.data?.preferences?.shipmentList ?? 'cards',
  )

  const handleViewChange = (nextView: ShipmentListPreference) => {
    setView(nextView)
  }

  return (
    <ConfirmedFiltersProvider>
      {view === 'cards' && (
        <ConfirmedShipmentList onViewChange={handleViewChange} />
      )}
      {view === 'condensed' && (
        <CondensedShipmentList onViewChange={handleViewChange} />
      )}
      {view === 'calendar' && (
        <CalendarShipmentList onViewChange={handleViewChange} />
      )}
    </ConfirmedFiltersProvider>
  )
}
